/**
 * @generated SignedSource<<e60a59fa0666e2598f01de1ff35fccd1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type WidgetIntegrationTurnpikeSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetNoteSize = "TWO_X_ONE" | "TWO_X_TWO";
export type WidgetOverviewSize = "TWO_X_FOUR" | "TWO_X_ONE" | "TWO_X_THREE" | "TWO_X_TWO";
export type WidgetTaskSingleSize = "ONE_X_ONE" | "TWO_X_ONE";
export type WidgetWeatherSize = "ONE_X_ONE" | "TWO_X_ONE";
import { FragmentRefs } from "relay-runtime";
export type useWidgetToPos_widget$data = ReadonlyArray<{
  readonly __typename: string;
  readonly id: string;
  readonly noteSize?: WidgetNoteSize;
  readonly overviewSize?: WidgetOverviewSize;
  readonly positionX: number;
  readonly positionY: number;
  readonly size?: WidgetWeatherSize;
  readonly subWidgets?: ReadonlyArray<{
    readonly height: number;
    readonly id: string;
    readonly positionX: number;
    readonly positionY: number;
  }>;
  readonly taskSingleSize?: WidgetTaskSingleSize;
  readonly turnpikeSize?: WidgetIntegrationTurnpikeSize;
  readonly " $fragmentType": "useWidgetToPos_widget";
}>;
export type useWidgetToPos_widget$key = ReadonlyArray<{
  readonly " $data"?: useWidgetToPos_widget$data;
  readonly " $fragmentSpreads": FragmentRefs<"useWidgetToPos_widget">;
}>;

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionX",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "positionY",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "useWidgetToPos_widget",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "overviewSize",
          "storageKey": null
        }
      ],
      "type": "WidgetOverview",
      "abstractKey": "__isWidgetOverview"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "noteSize",
          "storageKey": null
        }
      ],
      "type": "WidgetNote",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "taskSingleSize",
          "storageKey": null
        }
      ],
      "type": "WidgetTaskSingle",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "size",
          "storageKey": null
        }
      ],
      "type": "WidgetWeather",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "turnpikeSize",
          "storageKey": null
        }
      ],
      "type": "WidgetIntegrationTurnpike",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": null,
          "kind": "LinkedField",
          "name": "subWidgets",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            (v2/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "height",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "type": "WidgetSpace",
      "abstractKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    }
  ],
  "type": "Widget",
  "abstractKey": "__isWidget"
};
})();

(node as any).hash = "cd8b8d5fb5919093353f41c01d600879";

export default node;
